import type { ThemeType } from 'src/CrudManager/Core/composables/useTheme'

export const INFO_BOX_DEFAULTS = {
  LABEL: '',
  SUBTITLE: '',
  THEME: 'default' as ThemeType,
  VALUE_CLASS: 'text-subtitle2',
  DENSE: false,
  CAPTION: '',
  BADGE: '',
  BADGE_COLOR: 'primary',
  COPYABLE: null,
  COPY_VALUE: undefined,
  COPY_BTN_LABEL: null,
  NOTIFY_DURATION: 2000,
  HTML: false,
  MODEL_ID: undefined,
  MODEL_NAME: undefined,
  MODEL_BTN_ONLY: true,
  MODEL_PREFIX: '',
  MODEL_SUFFIX: '',
  TOOLTIP: undefined,
  EXPANDABLE: false,
  DEFAULT_EXPANDED: false,
  LABEL_CLASS: '',
  TEXT_CLASS: '',
  CHIP_CLASS: '',
  CHIP_ALWAYS: false,
  MODEL_VALUE: undefined,
} as const

export const TRANSITION_DURATION = {
  HEIGHT: 300,
  OPACITY: 250,
} as const
